import { type AppDispatch, type RootState } from '../../../../../store'

import _ from 'lodash'
import { addOffer } from '../../../addOffer'
type AddOfferIndividualOfferDetailsData = Record<string, any>
export const addOfferIndividualOfferDetails = (unitID: string | undefined, objectID: string | undefined) => (data: AddOfferIndividualOfferDetailsData) => async (dispatch: AppDispatch, getState: () => RootState) => {
    // const unit = getState().units.units?.find((unitItem) => unitItem.id === Number(unitID))
    // if (unit != null) {
    // const offerModalType = getOfferType(unit)
    const savedData = _.cloneDeep(getState().modal.scannedData.formData)
    const offerData = {
        ...data,
        ...savedData,
        Type: {
            ...data?.Type,
            ...savedData?.Type
        }
    }
    return await dispatch(addOffer(offerData, 'residential', Number(unitID), objectID !== '-' ? Number(objectID) : undefined))
    /* } else {
        return {
            isSuccessful: false
        }
    } */
}
